import {widgetFromDomaintypeGenerator} from "../../../misc/widget-functions"
import Content from "../../../components/Content"
import React, {useContext, useMemo} from "react"
import {DataContext} from "../../../../src/context/DataContextProvider"
import {checkConditionalMerkmal} from "../../../misc/condition-merkmal"

const QuestionToWidget = ({widget, merkmal, sections}) => {
    const {getDataFromPointer} = useContext(DataContext)
    const childWidget = useMemo(() =>
            widgetFromDomaintypeGenerator(merkmal, merkmal.pointer, widget.questionaire),
        [merkmal, widget.questionaire],
    )
    return (
        checkConditionalMerkmal(merkmal, sections, getDataFromPointer) && (
                <Content
                    child={childWidget}
                />
        )
    )
}

export default QuestionToWidget
